import { Component, OnInit } from '@angular/core';
import { SortingComponent } from '@spartacus/storefront';
import { NgSelectComponent, NgOptionComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-efa-order-sorting',
    templateUrl: './efa-order-sorting.component.html',
    imports: [NgSelectComponent, FormsModule, NgOptionComponent]
})
export class EfaOrderSortingComponent extends SortingComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
